var map = {
	"./projectView.png": 99564,
	"./projects": 9409,
	"./projects.json": 9409,
	"./urcSp24/Sp24DataTeam.jpg": 69012,
	"./urcSp24/Sp24UITeam.jpg": 51638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45580;